///////////////////////////////////////////////////////////////
// components/ConfirmationModal.jsx
export default function ConfirmationModal({ action, onConfirm, onCancel }) {
  return (
    <div className="modal-overlay">
      <div className="modal-panel modal-panel-sm border-l-4 border-yellow-500 p-4">
        <h3 className="mb-2 flex items-center text-lg font-bold text-slate-800">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
          CONFIRMACIÓN
        </h3>
        <p className="mb-3 text-sm text-slate-700">
          ¿ESTÁS SEGURO DE {action === 'guardar' ? 'guardar' : 'cancelar'} LOS DATOS?
        </p>
        <div className="modal-actions border-t border-slate-200 pt-3">
          <button
            onClick={onCancel}
            className="btn-modal-neutral"
          >
            NO
          </button>
          <button
            onClick={onConfirm}
            className="btn-modal-warning"
          >
            SÍ
          </button>
        </div>
      </div>
    </div>
  );
}
